<script>
import AppForm from '../components/AppForm';
import getFieldErrors from '../getFieldErrors';
import SubLoader from '../components/SubLoader';

export default {
  name: 'SignatureNoBankId',
  components: {
    AppForm,
    SubLoader,
  },
  data() {
    return {
      fieldErrors: {},
      signingProcess: {},
    }
  },
  computed: {
    inputValues() {
      return this.$root.$options.storeGetters.inputValues();
    },
    signatureIsProcessing() {
      return this.$root.$options.storeGetters.signatureIsProcessing();
    },
    additionalMethodConfig() {
      return this.$root.$options.storeGetters.additionalMethodConfig();
    },
    schema() {
      return [
        {
          type: 'text',
          name: 'name',
          validation: ['required'],
          label: this.$t('name'),
        },
        {
          type: 'submit',
          label: this.$t('Sign')
        }
      ]
    },
    formValue: {
      get() {
        return {
          name: this.inputValues.name,
        }
      },
      set(newValues) {
        this.updateInputValues(newValues);
      }
    },
  },
  methods: {
    updateInputValues(newValues) {
      this.$root.$options.storeActions.updateInputValues(newValues);
    },
    loadingStart() {
      this.$root.$options.storeActions.loadingStart();
    },
    loadingEnd() {
      this.$root.$options.storeActions.loadingEnd();
    },
    addFlashMessage(message) {
      this.$root.$options.storeActions.addFlashMessage(message);
    },
    clearFlashMessages() {
      this.$root.$options.storeActions.clearFlashMessages();
    },
    clearErrors() {
      this.fieldErrors = {};
    },
    cancel() {
      const {cancel} = this.signingProcess;
      if (cancel) {
        cancel();
      }
    },
    sign() {
      this.loadingStart();
      this.clearFlashMessages();
      this.clearErrors();

      const dataToSubmit = {
        ...this.formValue,
      };
      const additionalMethodConfig = this.additionalMethodConfig || {};
      this.signingProcess = this.$root.$options.eidEasyClient.signature.noBankIdAdvSignature.start({
        ...dataToSubmit,
        fail: (error) => {
          if (!error.isCancel) {
            this.addFlashMessage(error);
          }
          this.fieldErrors = getFieldErrors(error);
          this.$root.$options.eidEasyOnFail(error);
        },
        success: (result) => {
          this.$root.$options.eidEasyOnSuccess(result);
        },
        finished: () => {
          this.endSignatureProcessing();
          this.loadingEnd();
        },
        ...additionalMethodConfig,
      });
    }
  },
}
</script>

<template>
  <div :class="$style.formContainer">
    <div
      v-if="signatureIsProcessing"
      :class="$style.challenge"
    >
      <SubLoader />
    </div>
    <div v-else>
      <AppForm
        id="noBankIdSignatureForm"
        v-model="formValue"
        :schema="schema"
        :on-submit="sign"
        :errors="fieldErrors"
      />
    </div>
  </div>
</template>

<style lang="scss" module>
.formContainer {
  max-width: $form-container-width;
  margin: 0 auto;
}

.label {
  color: $gray-600;
  margin-top: $spacer-6;
}

.highlight {
  font-weight: $font-weight-bold;
  font-size: $font-size-xl;
}

</style>
